(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-internal-new-tab"]) return;
  try {
    
(() => {
  const initArticleInternalLinks = () => {
    const articleContainer = document.querySelector('.article-sidebar-shell');

    if (!articleContainer) return;

    const links = articleContainer.querySelectorAll('a[href]');

    links.forEach((link) => {
      const href = link.getAttribute('href');

      if (!href) return;

      if (
        href.startsWith('#') ||
        href.startsWith('tel:') ||
        href.startsWith('mailto:') ||
        href.startsWith('javascript:')
      ) {
        return;
      }

      try {
        const url = new URL(link.href, window.location.origin);

        if (url.origin === window.location.origin) {
          link.target = '_blank';
        }
      } catch (error) {
        console.warn('[Article New Tab] Invalid URL:', href);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initArticleInternalLinks,
      { once: true }
    );
  } else {
    initArticleInternalLinks();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
